<template>
     <v-dialog @click:outside="hideModal" :value="showInviteModal" width="800">
      <v-form ref="InvitationForm" @submit.prevent="inviteUser">
        <v-card>
          <v-card-title>
            <span class="headline ml-3">Invite New Members</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" sm="12" md="6">
                  <v-text-field
                    v-model="user.email"
                    :rules="invite.emailRules"
                    label="Email"
                    type="email"
                    solo
                    dense
                    hide-details="auto"
                    flat
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="6">
                  <v-text-field
                    v-model="user.firstName"
                    :rules="invite.firstNameRules"
                    label="First name"
                    solo
                    dense
                    hide-details="auto"
                    flat
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="6">
                  <v-text-field
                    v-model="user.lastName"
                    :rules="invite.lastNameRules"
                    label="Last name"
                    solo
                    dense
                    hide-details="auto"
                    flat
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="6">
                  <v-text-field
                    v-model="user.gdcNumber"
                    :rules="invite.gdcNumberRules"
                    label="Gdc number"
                    solo
                    dense
                    hide-details="auto"
                    flat
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="6">
                  <v-select
                    v-model="user.userPositionId"
                    :items="userPositions"
                    :rules="invite.userPositionIdRules"
                    label="User position"
                    solo
                    flat
                    dense
                    value
                    item-text="name"
                    item-value="id"
                    hide-details="auto"
                  ></v-select>
                </v-col>
              </v-row>
              <v-btn color="appGreen" type="submit" class="white--text"
                >Invite</v-btn
              >
            </v-container>
          </v-card-text>
        </v-card>
      </v-form>
    </v-dialog>
</template>

<script>
import { mapState } from "vuex";

export default {
   props: ['showInviteModal'],
   data: () => ({
    invite: {
      firstNameRules: [
        v => !!v || "Name is required",
        v => !!v && v.length >= 3 || "Name must be at least 3 characters",
        v => !!v && v.length <= 35 || "Name must be less than than 35 characters"
      ],
      lastNameRules: [
        v => !!v || "Name is required",
        v => !!v && v.length >= 3 || "Name must be at least 3 characters",
        v => !!v && v.length <= 35 || "Name must be less than than 35 characters"
      ],
      emailRules: [
        v => !!v || "E-mail is required",
        v => /.+@.+\..+/.test(v) || "E-mail must be valid"
      ],
      gdcNumberRules: [
        v => !!v || "GDC Number is required",
        v => !!v && v.length >= 1 || "GdcNumber must be at least 8 digits"
        // v => !!v && v.length <= 10 || "GdcNumber must be less than than 10 digits"
      ],
      userPositionIdRules: [v => !!v || "User position is required"]
    }
   }),
   computed: {
        ...mapState({

      userPositions: state => state.user.userPositions
    }),
   },
   methods: {
    hideModal() {
      this.$emit('close');
    },
    async inviteUser() {
      if (this.$refs.InvitationForm.validate()) {
        this.$swal({
          title: "Sending invite to user",
          html: "this may only take a moment...",
          icon: "info"
        });
        await this.$store.dispatch("surgery/INVITE_USER_TO_SURGER", this.user);
        this.$swal({
          title: "Success",
          html: "User has been invited",
          icon: "info"
        });
      }
    },
   }
}
</script>